import { useDispatch, useSelector } from "react-redux";
import { useBrand } from "../../../../../common/providers/brand/brand-context";
import { toggleLab } from "../../api/features/user/actions";
import { getLabEnabledStatuses } from "../../api/features/user/selectors";
import useUser from "../user/useUser";

export default function useLab() {
  const { loadStatus } = useUser();
  const labStatuses = useSelector(getLabEnabledStatuses);
  const dispatch = useDispatch();
  const brand = useBrand();

  return {
    loadStatus,
    labStatuses: () => dispatch(labStatuses),
    isEnabled: (id) =>
      (labStatuses[id]?.enabled && brand.getProp("Labs.enabled")) ?? false,
    toggleLab: (id) => dispatch(toggleLab(id)),
  };
}
